module.exports = ".add{\r\n    margin-right: 20px;\r\n}\r\n\r\n.search{\r\n    margin-left: 20px;\r\n    position: relative;\r\n    top: 4px;\r\n} \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/send-email/email-history/email-history.component.css
// module id = ./src/app/send-email/email-history/email-history.component.css
// module chunks = main